import { z } from "zod";
/**
 * Vardiya modülünün ortak sabitleri ve Türkçe etiketleri (Prompt 13; özellik bayrağı `SHIFTS`).
 * Değerler `packages/db/migrations/0015_shifts.sql` CHECK kısıtlarıyla BİREBİR aynıdır.
 */
export const SHIFT_STATUSES = ["OPEN", "CLOSING", "CLOSED", "APPROVED", "CANCELLED"];
export const shiftStatusSchema = z.enum(SHIFT_STATUSES);
export const SHIFT_STATUS_LABELS = {
    OPEN: "Açık",
    CLOSING: "Kapanış sürüyor",
    CLOSED: "Kapandı",
    APPROVED: "Onaylandı",
    CANCELLED: "İptal edildi",
};
/** Pompacı / kasiyer hesabının durumu (B aşaması kullanır; enum burada tanımlıdır). */
export const SHIFT_CLOSING_STATUSES = [
    "DRAFT",
    "SUBMITTED",
    "PENDING_APPROVAL",
    "ACCEPTED",
    "REJECTED",
];
export const shiftClosingStatusSchema = z.enum(SHIFT_CLOSING_STATUSES);
export const SHIFT_CLOSING_STATUS_LABELS = {
    DRAFT: "Giriliyor",
    SUBMITTED: "Teslim edildi",
    PENDING_APPROVAL: "Onay bekliyor",
    ACCEPTED: "Kabul edildi",
    REJECTED: "Reddedildi",
};
/** Personel görevi. `SUPERVISOR` vardiya üyesi OLAMAZ (hesabı yoktur); sorumlu müdür kaydıdır. */
export const STAFF_DUTIES = ["ATTENDANT", "CASHIER", "SUPERVISOR"];
export const staffDutySchema = z.enum(STAFF_DUTIES);
export const STAFF_DUTY_LABELS = {
    ATTENDANT: "Pompacı",
    CASHIER: "Kasiyer",
    SUPERVISOR: "Vardiya amiri",
};
/** Vardiya üyesinin görevi: hesap yalnızca pompacı ve kasiyer için açılır. */
export const SHIFT_MEMBER_DUTIES = ["ATTENDANT", "CASHIER"];
export const shiftMemberDutySchema = z.enum(SHIFT_MEMBER_DUTIES);
export const SHORTAGE_POLICIES = ["PERSONNEL", "EXPENSE"];
export const shortagePolicySchema = z.enum(SHORTAGE_POLICIES);
export const SHORTAGE_POLICY_LABELS = {
    PERSONNEL: "Personel carisine borç yazılır",
    EXPENSE: "Kasa açığı giderine yazılır",
};
export const SHIFT_ASSIGNMENT_TARGETS = ["NOZZLE", "CASH_REGISTER"];
export const shiftAssignmentTargetSchema = z.enum(SHIFT_ASSIGNMENT_TARGETS);
export const SHIFT_ASSIGNMENT_TARGET_LABELS = {
    NOZZLE: "Tabanca",
    CASH_REGISTER: "Kasa",
};
/** Atamanın açılış / kapanış endeksinin NEREDEN geldiği. */
export const SHIFT_TOTALIZER_SOURCES = ["AGENT", "LAST_READING", "HANDOVER", "MANUAL"];
export const shiftTotalizerSourceSchema = z.enum(SHIFT_TOTALIZER_SOURCES);
export const SHIFT_TOTALIZER_SOURCE_LABELS = {
    AGENT: "İstasyon ajanının anlık okuması",
    LAST_READING: "Son bilinen okuma",
    HANDOVER: "Vardiya içi devir okuması",
    MANUAL: "Elle girilen endeks",
};
/**
 * Ajan okumasının "anlık" sayılacağı en büyük yaş (dakika). Bunun üstündeki AGENT okuması `LAST_READING` sayılır.
 * Yasal dayanağı yoktur; operasyonel bir kabuldür.
 */
export const SHIFT_AGENT_READING_MAX_AGE_MINUTES = 10;
/** Nakit DIŞI tahsilat araçları (beyanda ve gün sonu özet fişinde kullanılır). */
export const SHIFT_TENDER_TYPES = [
    "CARD",
    "ON_ACCOUNT",
    "FLEET",
    "VEHICLE_RECOGNITION",
    "MOBILE_PAYMENT",
    "COUPON",
    "LOYALTY_POINTS",
];
export const shiftTenderTypeSchema = z.enum(SHIFT_TENDER_TYPES);
export const SHIFT_TENDER_TYPE_LABELS = {
    CARD: "Kredi / banka kartı",
    ON_ACCOUNT: "Veresiye (cari hesap)",
    FLEET: "Filo anlaşması",
    VEHICLE_RECOGNITION: "Taşıt tanıma sistemi (TTS)",
    MOBILE_PAYMENT: "Mobil ödeme",
    COUPON: "Kupon / fiş",
    LOYALTY_POINTS: "Sadakat puanı",
};
/** Vardiya içi satış fişinin türü — cari açık kalemi her ikisinde de oluşur. */
export const SHIFT_CREDIT_SALE_KINDS = ["ON_ACCOUNT", "FLEET"];
export const shiftCreditSaleKindSchema = z.enum(SHIFT_CREDIT_SALE_KINDS);
export const SHIFT_CREDIT_SALE_KIND_LABELS = {
    ON_ACCOUNT: "Veresiye fişi",
    FLEET: "Filo fişi",
};
/** Farkın nereye kapatıldığı (B aşaması). */
export const SHIFT_SETTLEMENT_TARGETS = ["PERSONNEL", "EXPENSE", "SURPLUS"];
export const shiftSettlementTargetSchema = z.enum(SHIFT_SETTLEMENT_TARGETS);
export const SHIFT_SETTLEMENT_TARGET_LABELS = {
    PERSONNEL: "Personelden alacak",
    EXPENSE: "Kasa açığı gideri",
    SURPLUS: "Kasa fazlası geliri",
};
/**
 * Hesabın BEKLENEN tutarı hesaplanırken üretilen uyarılar. Hiçbiri hesabı ENGELLEMEZ; arayüzde görünür ve
 * `shift_closings.expected_warnings` sütununda dondurulur.
 */
export const SHIFT_CLOSING_WARNINGS = [
    "PRORATED_BY_TIME",
    "TEST_EXCEEDS_TOTALIZER",
    "TRANSACTION_MISMATCH",
    "TOTALIZER_ANOMALY",
    "TOTALIZER_ROLLOVER",
    "NO_ASSIGNMENTS",
    "PROVISIONAL_CLOSING_TOTALIZER",
];
export const shiftClosingWarningSchema = z.enum(SHIFT_CLOSING_WARNINGS);
export const SHIFT_CLOSING_WARNING_LABELS = {
    PRORATED_BY_TIME: "Fiyat değişti ama işlem kaydı yok: endeks farkı dilimlere süreyle paylaştırıldı",
    TEST_EXCEEDS_TOTALIZER: "Test çekişi dilimin endeks payını aşıyor: dilim satışı sıfırlandı",
    TRANSACTION_MISMATCH: "Endeks farkı ile işlem kayıtlarının litre toplamı eşik üstünde ayrışıyor",
    TOTALIZER_ANOMALY: "Endeks serisinde anomali var (azalma ya da aşırı sıçrama): litre eksik olabilir",
    TOTALIZER_ROLLOVER: "Endeks sayacı taştı (rollover): litre taşma çözülerek hesaplandı",
    NO_ASSIGNMENTS: "Kişiye tabanca atanmamış: beklenen tutar sıfır",
    PROVISIONAL_CLOSING_TOTALIZER: "Kapanış endeksi henüz alınmadı: tutar son okumayla yapılan TAHMİNDİR",
};
/** ÖKC'nin hangi satışların fişini kestiği (C aşaması Z raporu karşılaştırmasında kullanılır). */
export const FISCAL_DEVICE_SCOPES = ["FUEL", "MARKET", "ALL"];
export const fiscalDeviceScopeSchema = z.enum(FISCAL_DEVICE_SCOPES);
export const FISCAL_DEVICE_SCOPE_LABELS = {
    FUEL: "Akaryakıt satışları",
    MARKET: "Market satışları",
    ALL: "Tüm satışlar",
};
export const Z_REPORT_SOURCES = ["AGENT", "MANUAL"];
export const zReportSourceSchema = z.enum(Z_REPORT_SOURCES);
export const Z_REPORT_SOURCE_LABELS = {
    AGENT: "İstasyon ajanı",
    MANUAL: "Elle giriş",
};
export const DAY_CLOSING_STATUSES = ["OPEN", "CLOSED"];
export const dayClosingStatusSchema = z.enum(DAY_CLOSING_STATUSES);
export const DAY_CLOSING_STATUS_LABELS = {
    OPEN: "Açık",
    CLOSED: "Kilitli",
};
export const SHIFT_LEDGER_STATUSES = ["NONE", "POSTED", "QUEUED"];
export const shiftLedgerStatusSchema = z.enum(SHIFT_LEDGER_STATUSES);
export const SHIFT_LEDGER_STATUS_LABELS = {
    NONE: "Fiş üretmedi",
    POSTED: "Muhasebeleşti",
    QUEUED: "Eşleştirme bekliyor",
};
/** Şablonun iş gününü kaydırması: 0 = başladığı gün, −1 = önceki gün, +1 = ertesi gün. */
export const BUSINESS_DAY_OFFSETS = [-1, 0, 1];
export const businessDayOffsetSchema = z
    .union([z.literal(-1), z.literal(0), z.literal(1)])
    .describe("İş günü kaydırması: 0 = vardiyanın başladığı gün");
/** Vardiyanın kasa hareketlerinde kullanılan kaynak belge türleri (hazine `origin.docType`). */
export const SHIFT_ORIGIN_MODULE = "SHIFTS";
export const SHIFT_FLOAT_DOC_TYPE = "SHIFT_FLOAT";
export const SHIFT_CASH_DROP_DOC_TYPE = "SHIFT_CASH_DROP";
export const SHIFT_CREDIT_SALE_DOC_TYPE = "SHIFT_CREDIT_SALE";
/** Kapanışta teslim edilen nakdin hazine kaydı (kasaya GİRİŞ; `EXTERNAL`). */
export const SHIFT_CLOSING_CASH_DOC_TYPE = "SHIFT_CLOSING_CASH";
/** Personele yazılan açığın cari açık kalemi (`PERSONNEL_RECEIVABLE`; fişi gün sonu özeti keser). */
export const SHIFT_SHORTAGE_DOC_TYPE = "SHIFT_SHORTAGE";
/** Vardiya farkının onay motorundaki belge türü. */
export const SHIFT_DIFFERENCE_DOC_TYPE = "SHIFT_DIFFERENCE";
//# sourceMappingURL=enums.js.map